/**
 * @fileoverview GET handler for the "/users/subscription_group_stats" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { usersSubscriptionGroupStats } from "./constants";
import type { UsersSubscriptionGroupStatsResult } from "./types";

export const getUsersSubscriptionGroupStats = reactQueryFetcherAdapter(
  usersSubscriptionGroupStats,
  (
    signal: AbortSignal,
    subscription_group_id: string,
    start_date: number,
    end_date: number
  ): Promise<UsersSubscriptionGroupStatsResult> => {
    return fetch(
      "/users/subscription_group_stats",
      "GET",
      { subscription_group_id, start_date, end_date },
      { signal }
    );
  }
);
